import { useAtomValue } from 'jotai';
import { locationsUrlParamsAtom } from 'src/atoms/filters/locations';
import { Routes } from 'src/Routes.constants';

export const useLocationsUrlFromFilters = () => {
  const urlParams = useAtomValue(locationsUrlParamsAtom);

  return `${Routes.locations}?${urlParams}`;
};
